import React from "react";

import Slider from "react-slick";

const Testimonials = () => {
  const reviews = [
    {
      name: "Liliia S.",
      position: "Junior Full Stack Web Developer",
      // src: "Liliia Shvorob profile picture",
      desc: "A true professional with a friendly and patient demeanor. He introduced me to coding through the Compass Course from StartSteps and instilled a belief in my programming potential. The resources and continuous support he provided were invaluable."
    },
    {
      name: "Ivan C.",
      position: "MBA Graduate, ACCA Student",
      // src: "Ivan Curmi profile picture",
      desc: "One of the best learning experiences I've had was in his web development class. He has a knack for breaking down complex coding concepts into engaging lessons. His dedication to student success and collaboration is truly inspiring."
    },
    {
      name: "Motahhareh S.",
      position: "WebApp Developer, Electronics Engineer",
      // src: "Motahhareh Samadi profile picture",
      desc: "Exceptional mentorship in web development was provided. His unparalleled expertise combined with his ability to make complex topics approachable is remarkable. His unwavering dedication to student success made a significant impact on my learning journey."
    },
    {
      name: "Aidan N.",
      position: "Junior Web Developer",
      // src: "Aidan Nee profile picture",
      desc: "Learning from him was a pleasure! With a deep well of knowledge, his generosity to our class was unmatched. He not only equipped us with tech resources but also served as a role model, always ready to share insights and advice."
    },
    {
      name: "Ismail A.",
      position: "Junior Full-Stack Web & App Developer",
      // src: "Ismail Alkanj profile picture",
      desc: "Through his teachings, I was introduced to the world of coding in a creative and efficient manner. His patience and dedication ensured our entire class progressed harmoniously. Immensely grateful for his guidance and support."
    },
    {
      name: "Shawn B. S.",
      position: "Let’s Start",
      // src: "Shawn B. S. profile picture",
      desc: "Among the best teachers I've encountered. He's patient, attentive, and has an open ear for questions. His teachings were thorough, engaging, and emphasized collaboration. Truly grateful for his dedication and invaluable insights."
    },
    {
      name: "Romano M.",
      position: "Junior Full Stack Web Developer",
      // src: "Romano Mantek profile picture",
      desc: "Easily one of the best coding instructors I've encountered. His passion for teaching coding and ensuring each student is engaged and understands the material was evident throughout the course. Grateful for his enthusiasm and guidance!"
    },
    {
      name: "Zoriana A.",
      position: "Kauffrau für Büromanagement, RM Group",
      // src: "Zoriana Atamanchuk profile picture",
      desc: "The classes were both engaging and enlightening. He has a unique energy, motivation, and patient teaching style that made the learning process a joy. Even after the course, his continued support has been invaluable."
    },
    {
      name: "Daniel C.",
      position: "Industrial + Interior Designer",
      // src: "Daniel Castro profile picture",
      desc: "His ability to ignite passion in students is commendable. In the Compass course, the teachings were interactive, ensuring we grasped foundational programming concepts. His dedication to ensuring each student's success is evident in his methodology."
    },
    {
      name: "Magdalena P.",
      position: "SEO Expert",
      // src: "Magdalena Polka profile picture",
      desc: "Highly recommended! An exceptional instructor with a patient and helpful teaching style. The depth of knowledge and guidance provided was truly beneficial."
    },
    {
      name: "Nikolay D.",
      position: "Assistant Director, UX/UI Designer",
      // src: "Nikolay Dimitrov profile picture",
      desc: "His teaching style is both passionate and knowledgeable. He ensured that complex topics were made accessible and engaging. His dedication to student success and his ability to cater to varying technical levels was particularly impressive."
    },
    {
      name: "Vullnet V.",
      position: "Digital Marketing Freelancer",
      // src: "Vullnet Veliaj profile picture",
      desc: "The Web Development classes were insightful and thoroughly enjoyable. His unique teaching approach kept me engaged and eager to learn more. His deep knowledge and experience in the field shone through every lesson."
    },
    {
      name: "Lum D.",
      position: "General Manager, Digital School",
      // src: "Lum Dalipi profile picture",
      desc: "A great colleague and team player. His dedication and willingness to support team initiatives have always been remarkable. His passion for teaching always made it a joy to work alongside him."
    },
    {
      name: "Daniel B.",
      position: "Orientierungsphase",
      // src: "Daniel Biedenstein profile picture",
      desc: "Dedicated and helpful, he stood out as an exemplary instructor at StartStep. His commitment and generous nature made the learning experience both rewarding and memorable."
    },
    {
      name: "João T.",
      position: "Software Engineer",
      // src: "João Teixeira profile picture",
      desc: "At StartSteps, the subjects of Web Development and Cyber Security were delivered with precision and depth. The entire cohort remained engaged, and by the end of the course, we all felt confident in foundational programming concepts."
    }
  ];

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
  };

  return (
    <section id="testimonial" className="section bg-secondary">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeIn">
          <span className="bg-primary text-dark px-2">What my Students and Clients say</span>
        </p>
        <h2 className="text-10 fw-600 text-white text-center mb-5 wow fadeIn">
          I Strive to leave every client with such experience
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-9 mx-auto wow fadeInUp">
            <Slider {...settings}>
              {reviews.length > 0 &&
                reviews.map((review, index) => (
                  <div className="item text-center px-5" key={index}>
                    {" "}
                    <span className="text-9 text-primary">
                      <i className="fa fa-quote-start" />
                    </span>
                    <p className="text-5 text-white">{review.desc}</p>
                    {/* <img
                      className="img-fluid d-inline-block w-auto rounded-circle shadow"
                      src={review.src}
                      alt={review.name}
                    />{" "} */}
                    <strong className="d-block text-3 fw-600 text-white">
                      {review.name}
                    </strong>{" "}
                    <span className="text-light">{review.position}</span>{" "}
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
